import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import Tab from 'react/containers/layout/tabs/Tab';
import { PaymentMethodTypeList } from './PaymentMethodTypeList';
import PaymentMethodTypeForm from './PaymentMethodTypeForm';

class PaymentMethodType extends Tab {
  static propTypes = {
    active: PropTypes.bool
  }

  static tabName = 'PaymentMethodType'

  activeClassName = 'is-active'

  getParametersFromPathName() {
    const { tab: { extra, pathname } } = this.props;
    const parentId = extra ? extra.parentId : null;
    const { length } = pathname.split('/');
    const index = (length - 2) + (length % 2);
    const [mode, id] = pathname.split('/').slice(index);

    return { mode, id, parentId };
  }

  render() {
    const { active } = this.props;
    const { id } = this.getParametersFromPathName();

    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <div id="PaymentMethodType" className={className}>
        <Switch>
          <Route exact path="/PaymentMethodType" component={PaymentMethodTypeList} />
          <Route path="/PaymentMethodType/new" component={() => <PaymentMethodTypeForm />} />
          <Route path="/PaymentMethodType/edit/:id" component={() => <PaymentMethodTypeForm id={id} />} />
        </Switch>
      </div>
    );
  }
}

export default PaymentMethodType;
